import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import { Link } from "react-router-dom";
import { isVacancyActive } from "../../utils/currentVacancy";
import { storyRouteLinkProps } from "./ctaTargets";
import { COLORS } from "../../theme/tokens";

function formatDutchDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("nl-NL", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export default function VacancyBanner({ block }) {
  const content = block?.content || {};
  if (!isVacancyActive(content)) return null;

  const deadline = formatDutchDate(content.applicationDeadline);
  const route = content.ctaRoute || "/vacatures";

  return (
    <Box
      component="section"
      aria-label="Actuele vacature"
      sx={{
        backgroundColor: COLORS.orange,
        color: COLORS.ink,
        px: "clamp(20px, 5vw, 72px)",
        py: { xs: 2, md: 2.5 },
        borderBottom: `1px solid ${COLORS.line}`,
      }}
    >
      <Container disableGutters maxWidth={false} sx={{ maxWidth: 1160 }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 1.5, md: 3 }}
          sx={{ alignItems: { xs: "flex-start", md: "center" } }}
        >
          <BusinessCenterOutlinedIcon aria-hidden="true" sx={{ fontSize: 34 }} />
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontSize: "0.76rem",
                fontWeight: 800,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
              }}
            >
              Actuele vacature
            </Typography>
            <Typography
              component="h2"
              sx={{
                fontFamily: "windroos, Georgia, serif",
                fontSize: { xs: "1.55rem", md: "2rem" },
                lineHeight: 1.15,
                fontWeight: 800,
              }}
            >
              {content.heading || "Werken op De Windroos"}
            </Typography>
            {deadline && (
              <Typography sx={{ mt: 0.5, fontWeight: 700 }}>
                Reageren kan tot {deadline}
              </Typography>
            )}
          </Box>
          <Button
            component={Link}
            {...storyRouteLinkProps(route)}
            variant="contained"
            sx={{
              m: 0,
              minHeight: 44,
              px: 2,
              borderRadius: 1,
              textTransform: "none",
              fontWeight: 800,
              backgroundColor: COLORS.blue,
              color: "#fff",
              "&:hover": { backgroundColor: COLORS.red },
            }}
          >
            {content.ctaLabel || "Bekijk vacature"} →
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
